// initial state
const state = () => ({
    dropdowns: {},
    roles: {}
})

// getters
const getters = {
    getStateGenericDropdowns(state) {
      return state.dropdowns;
    },
    getStateGenericRoles(state) {
      return state.roles;
    }
}

// actions
const actions = {}

// mutations
const mutations = {
    clearStateGenericDropdowns(state) {
        state.dropdowns = {};
    },
    setStateGenericDropdowns(state, payload) {
      for (var [key, value] of Object.entries(payload)) {
        state.dropdowns[key] = value;
      }
    },
    setStateGenericRoles(state, payload) {
        const arrayOfObj = [];
        for (var [key, value] of Object.entries(payload)) {
            state.roles[key] = value;
            arrayOfObj.push(state.roles[key])
        }
        state.roles = arrayOfObj;
    }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
